module.exports = __webpack_public_path__ + "static/media/live.a9e69b7a.png";